/**
 * 🔥 PROTECTION RADICALE CONTRE LES ERREURS removeChild
 * Monkey-patch du DOM pour rendre removeChild, remove(), etc. 100% sûrs
 * Cette protection s'applique AVANT que React ne crash
 */

(function() {
  'use strict';
  
  if (typeof window === 'undefined' || typeof Node === 'undefined') {
    return;
  }

  // Sauvegarder les méthodes originales
  const OriginalNodePrototype = Node.prototype;
  const originalRemoveChild = OriginalNodePrototype.removeChild;
  const originalRemove = OriginalNodePrototype.remove;
  const originalAppendChild = OriginalNodePrototype.appendChild;
  const originalInsertBefore = OriginalNodePrototype.insertBefore;
  const originalReplaceChild = OriginalNodePrototype.replaceChild;

  // 🔥 MONKEY-PATCH removeChild - PROTECTION TOTALE
  OriginalNodePrototype.removeChild = function(child) {
    try {
      if (!child || !(child instanceof Node)) {
        console.warn('[DOM Protection] removeChild called with invalid child:', child);
        return child;
      }

      // Si pas de parent, c'est déjà supprimé, on retourne silencieusement
      if (!child.parentNode) {
        return child;
      }

      // Vérifier que child est bien un enfant de this
      if (!this.contains(child)) {
        console.warn('[DOM Protection] removeChild: node is not a child, ignoring');
        return child;
      }

      // Tentative sécurisée
      try {
        return originalRemoveChild.call(this, child);
      } catch (err) {
        // Si ça échoue, essayer avec remove()
        console.warn('[DOM Protection] removeChild failed, trying remove():', err.message);
        try {
          if (typeof child.remove === 'function') {
            child.remove();
            return child;
          }
        } catch (e2) {
          console.warn('[DOM Protection] remove() also failed, ignoring:', e2.message);
        }
        return child;
      }
    } catch (err) {
      // Ne JAMAIS crasher l'app pour une erreur DOM
      console.warn('[DOM Protection] removeChild global error (ignored):', err.message);
      return child;
    }
  };

  // 🔥 MONKEY-PATCH remove() - PROTECTION TOTALE
  if (typeof originalRemove === 'function') {
    OriginalNodePrototype.remove = function() {
      try {
        // Si pas de parent, déjà supprimé
        if (!this.parentNode) {
          return;
        }

        // Vérifier que le node est bien dans le DOM
        if (!this.parentNode.contains(this)) {
          return;
        }

        // Tentative sécurisée
        try {
          return originalRemove.call(this);
        } catch (err) {
          // Fallback sur removeChild
          try {
            if (this.parentNode) {
              originalRemoveChild.call(this.parentNode, this);
            }
          } catch (e2) {
            // Ignorer silencieusement
            console.warn('[DOM Protection] remove() fallback failed (ignored):', e2.message);
          }
        }
      } catch (err) {
        // Ne JAMAIS crasher
        console.warn('[DOM Protection] remove() global error (ignored):', err.message);
      }
    };
  }

  // 🔥 MONKEY-PATCH appendChild - PROTECTION CONTRE LES DOUBLONS
  OriginalNodePrototype.appendChild = function(child) {
    try {
      if (!child || !(child instanceof Node)) {
        console.warn('[DOM Protection] appendChild called with invalid child');
        return child;
      }

      // Si l'enfant est déjà enfant de ce parent, ne rien faire
      if (this.contains(child)) {
        return child;
      }

      return originalAppendChild.call(this, child);
    } catch (err) {
      console.warn('[DOM Protection] appendChild error (ignored):', err.message);
      return child;
    }
  };

  // 🔥 MONKEY-PATCH insertBefore - PROTECTION
  OriginalNodePrototype.insertBefore = function(newNode, referenceNode) {
    try {
      if (!newNode || !(newNode instanceof Node)) {
        console.warn('[DOM Protection] insertBefore called with invalid newNode');
        return newNode;
      }

      // Si newNode est déjà enfant de this, le retirer d'abord
      if (this.contains(newNode)) {
        try {
          originalRemoveChild.call(this, newNode);
        } catch (e) {
          // Ignorer si déjà retiré
        }
      }

      return originalInsertBefore.call(this, newNode, referenceNode);
    } catch (err) {
      console.warn('[DOM Protection] insertBefore error (ignored):', err.message);
      return newNode;
    }
  };

  // 🔥 MONKEY-PATCH replaceChild - PROTECTION
  OriginalNodePrototype.replaceChild = function(newChild, oldChild) {
    try {
      if (!newChild || !(newChild instanceof Node) || !oldChild || !(oldChild instanceof Node)) {
        console.warn('[DOM Protection] replaceChild called with invalid nodes');
        return oldChild;
      }

      // Vérifier que oldChild est bien un enfant
      if (!this.contains(oldChild)) {
        console.warn('[DOM Protection] replaceChild: oldChild is not a child, trying append');
        try {
          return originalAppendChild.call(this, newChild);
        } catch (e) {
          return oldChild;
        }
      }

      return originalReplaceChild.call(this, newChild, oldChild);
    } catch (err) {
      console.warn('[DOM Protection] replaceChild error (ignored):', err.message);
      return oldChild;
    }
  };

  // 🔥 PROTECTION GLOBALE DES ERREURS NON-CAPTURÉES
  const originalErrorHandler = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    // Intercepter les erreurs removeChild
    if (message && typeof message === 'string') {
      if (
        message.includes('removeChild') ||
        message.includes('NotFoundError') ||
        message.includes('Failed to execute')
      ) {
        console.warn('[DOM Protection] Intercepted removeChild error:', message);
        // Empêcher la propagation de l'erreur
        return true;
      }
    }

    // Appeler le handler original si présent
    if (typeof originalErrorHandler === 'function') {
      return originalErrorHandler.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  // 🔥 PROTECTION DES PROMISES REJECTED NON-CAPTURÉES
  const originalUnhandledRejection = window.onunhandledrejection;
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && typeof event.reason === 'object') {
      const message = event.reason.message || String(event.reason);
      if (
        message.includes('removeChild') ||
        message.includes('NotFoundError') ||
        message.includes('Failed to execute')
      ) {
        console.warn('[DOM Protection] Intercepted removeChild promise rejection:', message);
        event.preventDefault(); // Empêcher le crash
        return;
      }
    }

    // Appeler le handler original si présent
    if (typeof originalUnhandledRejection === 'function') {
      originalUnhandledRejection.call(window, event);
    }
  });

  console.log('✅ [DOM Protection] Protection radicale activée - removeChild ne crashra plus jamais');
})();

